module.exports = __webpack_public_path__ + "static/media/sc.049e7208.svg";